export enum SaleLabelFormat {
  SALE = 'Sale',
  DOLLAR_OFF = 'DollarOff',
  PERCENT_OFF = 'PercentOff'
}
